import dayjs from 'dayjs';
import { isNullish, omit } from 'remeda';

import { initialValues, LotterySettingsForm, normalizePrizeText } from './form';

import { LotterySettings, LotterySettingsPayload } from 'v2/types/LotteryModel';

export function mapDtoToForm(data?: LotterySettings): LotterySettingsForm {
  if (isNullish(data)) return initialValues;

  return {
    ...initialValues,
    ...data.backgroundImages,
    ...omit(data, ['id', 'backgroundImages', 'startDate', 'endDate']),
    startDate: data.startDate ? dayjs(data.startDate) : null,
    endDate: dayjs(data.endDate),
    prizePlacesCount: data.prizePlacesCount ? String(data.prizePlacesCount) : '',
    prizes: (data.prizes ?? []).map((prize) => ({
      name: normalizePrizeText(prize.name),
      description: normalizePrizeText(prize.description),
    })),
  };
}

export function mapFormToDto(form: LotterySettingsForm): LotterySettingsPayload {
  return {
    shortDescription: form.shortDescription,
    fullDescription: form.fullDescription,
    casinoId: form.casinoId,
    type: form.type,
    backgroundImages: {
      desktopImage: form.desktopImage,
      tabletImage: form.tabletImage,
      mobileImage: form.mobileImage,
    },
    isActive: form.isActive,
    startDate: form.startDate?.startOf('minute').format() ?? null,
    endDate: form.endDate.startOf('minute').format(),
    prizePlacesCount: form.prizePlacesCount ? Number.parseInt(form.prizePlacesCount, 10) : null,
    prizes: form.prizes.map((prize) => ({
      name: normalizePrizeText(prize.name),
      description: normalizePrizeText(prize.description),
    })),
  };
}
